<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content" style="padding: 0px!important;">
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
    </section>
  </div>
</template>
<script>
  export default {
    name: 'va-content-wrap',
    data () {
      return {
        showSearch: false,
        showNewBtn: false
      }
    },
    created () {
      // console.log('content-wrapper created')
    },
    ready () {
      // console.log('content-wrapper ready')
    },
    mounted () {
      // console.log('content-wrapper mounted')
    },
    updated () {
      // console.log('content-wrapper updated')
      this.showSearch = (this.$route.name !== 'Dashboard' && this.$route.name !== 'Account' && this.$route.name !== 'Settings' && this.$route.name !== 'Reports')
      this.showNewBtn = (this.$route.name !== 'Dashboard' && this.$route.name !== 'Account' && this.$route.name !== 'Settings' && this.$route.name !== 'Reports' && this.$route.name !== 'Printers' && this.$route.name !== 'History')
    },
    computed: {
    },
    methods: {
    }
  }
</script>
<style>

  .page-enter-active, .page-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
  }

  .content-wrapper {
    height: 90vh !important;
    min-height: 90vh !important;
    overflow-y: auto;
  }

  tbody tr:nth-child(odd) {
    background-color: #dedede;
    background-color: #dce7f0;
  }
</style>



// WEBPACK FOOTER //
// ContentWrapMobile.vue?167e9988